theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    
    if(headerStickyTarget){
      let headerTop = headerStickyWrapper.offsetTop; // <-- key change
      let headerHeight = headerStickyWrapper.clientHeight;

      window.addEventListener('scroll', function(){
if(window.scrollY > headerTop + headerHeight){
  headerStickyTarget.classList.add('sticky');
  document.body.style.paddingTop = headerHeight + "px"; // reserve space
} else {
  headerStickyTarget.classList.remove('sticky');
  document.body.style.paddingTop = 0;
}
      });
    }
  }
  return ScrollSticky;
})();
